import { twMerge } from "tailwind-merge";

export type ColumnProp = {
    heading: string
    content: React.ReactNode
}

export type ColumnCardProps = {
    columns: ColumnProp[]
    className?: string
}

const ColumnCard = (props: ColumnCardProps) => {

    return (
        <div 
            className={twMerge(
                "grid gap-4 border border-secondary-100 rounded-lg divide-x divide-secondary-100", 
                props.className,
            )}
        >
            {
                props.columns.map((el) => (
                    <div className="py-2 px-3" key={el.heading}>
                        <h4 className="text-[#6B5C4F] text-xs 3xl:text-sm mb-3">
                            {el.heading}
                        </h4>
                        
                        <div className="text-sm">
                            {el.content}
                        </div>
                    </div>
                ))
            }
        </div>
    )
}

export default ColumnCard